import { Button, Card, InputField } from '@branchjs/neo-components';
import { cx } from '@emotion/css';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import LoggedoutActions from '../../../main/actions/LoggedoutActions';
import { ImageService } from '../../../main/services/ImageService/ImageService';
import LoggedOutStore from '../../../main/stores/LoggedoutStore';
import FullScreenWrapperWithBranchLogo from '../FullScreenWrapperWithBranchLogo';
import { ERROR_MESSAGES } from '../constants/errorMessages.constants';
import { useStyles } from './ScreenResendVerificationEmail.styles';

const IMAGE_RESEND_EMAIL_FILE_LOCATION = '/static/images/loggedout/img_resend_email.svg';

export const ScreenResendVerificationEmail = ({ userEmailAddress }: { userEmailAddress: string }) => {
  const { card, cardContent, cardTitle, image, resendEmailTextBlock, mainText, formInput } = useStyles();
  const history = useHistory();
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleRemainingErrors = (errors: Record<string, any>): void => {
    setShowError(true);
    if (errors.status === 429) {
      setErrorMessage(ERROR_MESSAGES.RATE_LIMIT);
    } else {
      setErrorMessage(ERROR_MESSAGES.UNKNOWN);
    }
  };

  const resendVerification = async (): Promise<boolean> => {
    await LoggedoutActions.resendVerificationEmail(userEmailAddress);
    const errors = LoggedOutStore.getErrors();
    if (errors.data) {
      handleRemainingErrors(errors);
      return false;
    }
    return true;
  };

  const onButtonClick = async (): Promise<void> => {
    const resendWasSuccessful = await resendVerification();
    if (resendWasSuccessful) {
      history.push('/email-sent', { emailSentRouteEnabled: true });
    }
  };

  return (
    <FullScreenWrapperWithBranchLogo>
      <Card className={card}>
        <div className={cardContent}>
          <div className={cardTitle} id="verify-email--header-title">
            Resend email
          </div>
          <img
            className={image}
            data-testid="verify-email--header-image"
            src={ImageService.getImageUrl(IMAGE_RESEND_EMAIL_FILE_LOCATION)}
          />
          <p className={cx(mainText, resendEmailTextBlock)}>
            If you have not received the verification email yet, or if your token has expired, you can enter your email
            address below and we'll resend the verification email.
          </p>
          <InputField
            id="verify-email__email-address"
            testid="verify-email__email-address-input"
            className={formInput}
            fullWidth
            title="Email address"
            value={userEmailAddress}
            disabled
            error={showError}
            helperText={showError ? errorMessage : undefined}
          />
          <Button
            id="btn-verify-email__resend-email"
            testid="btn-verify-email__resend-email"
            onClick={onButtonClick}
            variant="contained"
          >
            Resend Email
          </Button>
        </div>
      </Card>
    </FullScreenWrapperWithBranchLogo>
  );
};
